export const COLLISION_STATES = ['viewing', 'replying', 'noting', 'typing']
export const REFETCH_COLLISIONS_INTERVAL = 300000 // 300 seconds, a.k.a. 5 minutes
